import styled from 'styled-components'
import { em, rem, color, rgba } from '../../utils/styles'

const IconButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${rem(2)} solid ${rgba('base', 0.3)};
  border-radius: 50%;
  width: ${em(40)};
  height: ${em(40)};
  background-color: transparent;
  transition: all 100ms ease-in-out;
  cursor: pointer;

  .focus-parent:focus &,
  &:focus {
    border-color: ${rgba('base', 1)};
    background-color: ${color('base')};
    color: ${color('white')};
  }

  .focus-parent:hover &,
  &:hover {
    border-color: ${rgba('base', 1)};
  }

  svg {
    width: ${em(16)};
    height: ${em(16)};
  }
`

export default IconButton
